import { createThunk, ListModel, model } from 'mst-collection';

import { Api } from '@api';
import { TrackFeedbackModel } from './TrackFeedbackModel';

export class TrackFeedbacksList extends ListModel(
  TrackFeedbackModel,
  {
    pageSize: 30,
  },
) {
  fetch = createThunk(() => {
    return async function fetch(this: TrackFeedbacksList) {
      const res = await Api.Tracks.getTrackFeedbacks();

      this.set(res.data.tracks);
    };
  });
}

export const TrackFeedbacksListModel = model(TrackFeedbacksList);
